<template>
    <div class="fileupload">
        <div class="load-block" v-if="editSection4">
            <span class="file-upload-trigger" @click="triggerModal">
                <i class="icon icon-analytics"></i> <b>{{ getLocText('upload_file') }}</b>
            </span>
        </div>

        <b-tabs class="inside-content" v-model="activeTabIndex">
            <b-tab v-for="category in categoriesWithFiles" :key="category.code">
                <template #title>
                    {{ category.name }}
                    (<span>{{ category.files.length }}</span>)
                </template>

                <!-- Files for this category -->
                <template v-for="(cF, index) in category.files">
                    <div class="file-info" :key="index">
                        <p class="date">{{ cF.date }}</p>
                        <p class="icon">
                            <file-icons :filename="cF.name"></file-icons>
                        </p>
                        <p class="name">
                            <span class="fileupload_file-name" @click="downloadFile(cF.name)">{{ cF.name }}</span>
                        </p>
                        <p class="size">{{ cF.sizeFormatted }}</p>
                        <p class="delete" @click="delFile(cF)">
                            <i class="icon icon-close" style="margin-right: 0"></i>
                            <span>{{ getLocText('delete') }}</span>
                        </p>
                        <div class="comment ml-auto"
                             :class="cF.text.trim().length === 0 ? 'border-red': ''">
                            <b-form-textarea
                                id="textarea"
                                v-model="cF.text"
                                class="compact-textarea"
                                :placeholder="trMsg(MSG_SMS + 'add_description_doc')"
                                rows="2"
                                @input="editFile(cF)"
                                :disabled="!editSection4">
                            </b-form-textarea>
                        </div>
                    </div>
                </template>
            </b-tab>

            <template #tabs-end v-if="localFiles.length > 0">
                <li role="presentation" class="nav-item align-self-center ml-auto">
                    <div style="display: flex;">
                    <b-spinner v-if="isAllFileDownloading" small variant="success" label="Spinning" class="spinner"></b-spinner>
                    <a href="#" class="nav-link download-all" @click="(e) => downloadFiles(e, false)">
                      {{ getLocText('download_all') }}
                      <span>({{(localFiles && localFiles.length > 0) ? localFiles.length : 0}})</span></a>
                  </div>
                </li>
                <li role="presentation" class="nav-item align-self-center">
                    <div style="display: flex; margin-right: 50px">
                        <p class="nav-link delete-all" @click="deleteFiles">
                        <i v-if="!filesDeleting" class="icon icon-close"></i>
                        <b-spinner v-if="filesDeleting" small variant="danger" label="Spinning"></b-spinner>
                        {{ getLocText('del_all') }} <span>({{localFiles.length}})</span>
                        </p>
                    </div>
                </li>
            </template>
        </b-tabs>

        <b-modal ref="modalFileUpload"
                 id="modal-file-upload"
                 modal-class="modal-file-upload"
                 v-model="modalFileUpload"
                 centered hide-header hide-footer
                 size="l">
          <b-overlay :show="btnDisabled" rounded="sm">
              <div class="modal-title">{{ getLocText('select_cat') }}</div>

              <b-form-group>
                  <multiselect v-model="selCategoryItem"
                               class="category-select"
                               track-by="code"
                               label="name"
                               :options="categories"
                               :placeholder="getLocText('select_cat')"
                               :searchable="true"
                               :allow-empty="false"
                               :show-labels="false"
                               open-direction="below"
                               :max-height="250">
                  </multiselect>
              </b-form-group>

              <b-form-file id="file" ref="file-input"
                           accept="*.*"
                           @input="uploadFile"
                           multiple
                           :placeholder="getLocText('upload')"
                           :disabled="selCategory === null">
              </b-form-file>
            <p class="upload-btn-label">({{ getLocText('max_size', {size: 30}) }})</p>
          </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Ax } from '@/utils';
import axios from 'axios';
import FileUploadMixin from '@/modules/budget/bip/file-upload-mixin';
import FileIcons from '@/modules/budget-request/components/file-icons.vue';
import {
    findItem,
    formatFileSize,
    makeToast,
    maxFileSize,
    MSG_CARD_SEC,
    MSG_SMS,
    showConfirmation,
    trMsg,
    locale, validateFilesText
} from "@/modules/budget/bip/bip-types";
import i18nService from "@/services/i18n";

export default {
    name: 'FileUpload',
    components: { FileIcons },
    props: {
        bip: null,
        editSection4: null,
        fundSrcList: null,
        reading: null
    },
    mixins: [FileUploadMixin],
    data() {
        return {
            noPreviewExtentions: [
                '.7z', '.ace', '.arj', '.bin', '.bin', '.cab', '.cab', '.cbr', '.deb', '.exe', '.gz',
                '.gzip', '.jar', '.one', '.pak', '.pak', '.pak', '.pkg', '.pkg', '.pkg', '.pkg',
                '.ppt', '.rar', '.rpm', '.sh', '.sib', '.sis', '.sisx', '.sit', '.sitx', '.spl',
                '.spl', '.tar', '.tar-gz', '.tgz', '.xar', '.zip', '.zip', '.zipx'
            ],
            localFiles: [...this.bip.files], // создаем локальную копию
            activeTabIndex: 0,
            comment: '',

            isAllFileDownloading: false,
            filesDeleting: false,
            modalFileUpload: false,
            uploadInProgress: false,
            btnDisabled: false,

            selCategory: null
        };
    },

    async created() {
        await this.loadDict();
        this.$watch('load', this.loadFiles);
    },

    methods: {
        // Активировать вкладку категории по коду
        activateCategoryTab(categoryCode) {
            const index = this.categoriesWithFiles.findIndex(
                cat => cat.code === categoryCode
            );
            if (index !== -1) {
                this.activeTabIndex = index;
            }
        },

        createNewFile(originalFile, newName) {
            try {
                return new File([originalFile], newName, {
                    type: originalFile.type || 'application/octet-stream'
                });
            } catch (error) {
                console.error('Error creating File object:', error);
                return originalFile;
            }
        },

        closeModal() {
            this.modalFileUpload = !this.modalFileUpload;
            this.comment = '';
            this.selCategory = null;
        },

        async delFile(file) {
          await showConfirmation(this,
              trMsg(this, MSG_SMS + 'delete_file'),
              () => {
                  this.deleteFile(file);
                  // Активируем вкладку категории файла
                  if (file.category) {
                      this.$nextTick(() => {
                          this.activateCategoryTab(file.category);
                      });
                  }},
              () => { return });
        }, // удаление файла

        async deleteFile(file) {
            try {
                Ax({
                      url: '/api-py/file-delete/' + this.bip.header.year + '/' + this.bip.code + '/' + file.name + '/',
                      method: 'POST',
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json' // Изменил на application/json
                      },
                      data: {},
                      responseType: 'json'
                    },
                    () => {
                    // Удаляем файл из основного списка files
                    this.localFiles = this.localFiles.filter(fl =>
                      fl.name !== file.name || fl.category !== file.category);
                    this.$emit('getFiles', this.localFiles);

                    // Удаляем файл из категорий по коду и названию
                    this.removeFileFromCategories(file);

                    makeToast(this, 'success', trMsg(this, 'message'),
                      trMsg(this, 'file_deleted'));
                    },
                    (error) => {
                    makeToast(this, 'danger', trMsg(this, 'warning'), error.toString());
                    }
                );
            } catch {
            makeToast(this, 'danger', trMsg(this, 'error_delete'), '');
            }
        }, // удаляет файл с хранилища

        deleteFiles() {
            showConfirmation(this,
                trMsg(this, MSG_SMS + 'delete_files'),
                () => {
                    this.deleteAllFiles();
                },
                () => {
                    return;
                });
        }, // удаление всех файлов

        async deleteAllFiles() {
            this.filesDeleting = true;
            try {
                const response = await fetch('/api-py/files-delete/' + this.bip.header.year + '/' + this.bip.code, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('Delete response:', data);

                if (data.result === 'success') {
                    const deletedCount = data.deleted_files ? data.deleted_files.length : 0;

                    this.localFiles = [];
                    this.$emit('getFiles', this.localFiles);

                    makeToast(this, 'success', trMsg(this, 'message'),
                        trMsg(this, 'all_files_deleted') + ` (${deletedCount})`);
                } else {
                    makeToast(this, 'danger', trMsg(this, 'warning'),
                        data.message || trMsg(this, 'delete_failed'));
                }

            } catch (error) {
                makeToast(this, 'danger', trMsg(this, 'warning'), error.message);
            } finally {
                this.filesDeleting = false;
            }
        },

        downloadFile(filename) {
            Ax(
                {
                    url: `/api-py/file-download/${this.bip.header.year}/${this.bip.code}/${filename}`,
                    method: 'POST',
                    data: null,
                    responseType: 'blob'
                },
                (data) => {
                    // Создаем URL для blob
                    const url = URL.createObjectURL(data);

                    // Создаем и настраиваем ссылку для скачивания
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    link.style.display = 'none';

                    // Добавляем в DOM, кликаем и очищаем
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Освобождаем память
                    URL.revokeObjectURL(url);
                },
                (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_download'),
                        error.toString());
                }
            );
        },

        downloadFolder() {
            Ax(
                {
                    url: `/api-py/files-download/${this.bip.header.year}/${this.bip.code}`,
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const zipFilename = `files-${this.bip.header.year}-${this.bip.code}.zip`;
                    const url = URL.createObjectURL(data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = zipFilename;
                    link.style.display = 'none';

                    document.body.appendChild(link);
                    link.click();

                    setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    }, 100);

                    makeToast(this, 'success', trMsg(this, MSG_SMS + 'success'),
                        'All files downloaded as ZIP archive');
                },
                (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_download'),
                        error.toString());
                }
            );
        }, // скачать архив всех прикрепленных файлов

        downloadFiles() {

            const selectedFiles = this.localFiles
                .map(file => file.name); // получаем только имена файлов

            Ax(
                {
                    url: `/api-py/files-download/${this.bip.header.year}/${this.bip.code}`,
                    method: 'POST',
                    responseType: 'blob',
                    data: selectedFiles  // отправляем массив имен файлов
                },
                (data) => {
                    const zipFilename = `files-${this.bip.header.year}-${this.bip.code}.zip`;
                    const url = URL.createObjectURL(data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = zipFilename;
                    link.style.display = 'none';

                    document.body.appendChild(link);
                    link.click();

                    setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    }, 100);

                    makeToast(this, 'success', trMsg(this, MSG_SMS + 'success'),
                        `${selectedFiles.length} files downloaded as ZIP archive`);
                },
                (error) => {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_download'),
                        error.toString());
                }
            );
        },

        editFile(item) {
            const index = this.localFiles.findIndex(file =>
              file.category === item.category && file.name === item.name);

            if (index !== -1) {
                this.$set(this.localFiles, index, { ...this.localFiles[index], ...item });
            }

            // Активируем вкладку категории файла
            if (item.category) {
                this.activateCategoryTab(item.category);
            }

            this.$emit('getFiles', this.localFiles);
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },

        async getFilesFromServer() {
            try {
                Ax(
                    {
                        url: '/api-py/get-files/' + this.bip.header.year + '/' + this.bip.code,
                        method: 'GET'
                    },
                    (response) => {
                        if (response.data && response.data.files) {
                            this.localFiles = response.data.files;
                        }
                    },
                    (error) => {
                        console.error('Error fetching files:', error);
                        // Даже если ошибка, очищаем локальный список
                        this.localFiles = [];
                    }
                );
            } catch (error) {
                console.error('Error in getFilesFromServer:', error);
                this.localFiles = [];
            }
        },

        getFiles() {
            const files = [];

            this.categoriesWithFiles.forEach(cat => {
                cat.files.forEach(file => { files.push(file); });
            });
            this.$emit('getFiles', files);

            this.loadFiles();
        },

        async loadFiles() {
            this.categories.forEach(cat => {
                // Если у файла нет категории, присваиваем код '2010'
                cat.files = [];
            });
            this.localFiles.forEach(file => {
                // Если у файла нет категории, присваиваем код '2010'
                if (!file.category) {
                    file.category = '2010';
                }
                file.date = this.formatDate(file.date_created);
                const category = this.categories.find(cat => cat.code === file.category);
                if (category) {
                    category.files.push(file);
                }
            });
        },

        removeFileFromCategories(file) {
          // Если категории хранятся в массиве
          this.categories.forEach(category => {
            if (category.files && Array.isArray(category.files)) {
              // Удаляем файл по коду и названию
              category.files = category.files.filter(fl =>
                  !(fl.category !== file.category && fl.name !== file.name)
              );
            }
          });
        },

        async triggerModal(event) {

            // Проверяем условие блокировки
            if (!this.validateFText) {
                makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'fill_info_attached_docs') + '(' + trMsg(this, MSG_CARD_SEC + '1.title') + ')');
                event.preventDefault();
                event.stopPropagation();

                return;
            } else {
                this.modalFileUpload = !this.modalFileUpload;
            }
        },

        async uploadFile() {

            // Защита от повторного вызова
            if (this.uploadInProgress) {
                console.log('Upload already in progress, skipping...');
                return;
            }

            // Проверка BIP-00000
            if (this.bip.code === 'BIP-00000') {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'),
                  trMsg(this, MSG_SMS + 'first_save_BIP'));
                return;
            }

            this.uploadInProgress = true;

            try {
                // Берем файлы напрямую из input компонента
                const fileInput = this.$refs['file-input'];
                if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
                    console.log('No files selected in input');
                    return;
                }

                const files = fileInput.files;
                let successCount = 0;
                let errorCount = 0;
                const errorMessages = [];

                // Обрабатываем каждый файл
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];

                    try {
                        const fileSize = file.size || 0;
                        const formattedSize = formatFileSize(fileSize);

                        // Проверка размера файла (30 МБ = 30 * 1024 * 1024 байт)
                        if (fileSize > maxFileSize) {
                            const errorMsg = `Файл "${file.name}" (${formattedSize}) слишком большой. Максимальный размер: ${formatFileSize(maxFileSize)}`;
                            errorMessages.push(errorMsg);
                            errorCount++;
                            continue; // Пропускаем этот файл и переходим к следующему
                        }

                        const newName = file.name.replace(/\s+/g, "_");
                        const newFile = this.createNewFile(file, newName);

                        const formData = new FormData();
                        formData.append('file', newFile);
                        formData.append('filetype', newFile.type);
                        formData.append('filename', newFile.name);
                        formData.append('filesize', fileSize.toString());
                        formData.append('year', this.bip.header.year);
                        formData.append('code', this.bip.code);

                        const newItem = {
                            type: newFile.type,
                            name: newFile.name,
                            text: this.comment,
                            size: fileSize,
                            sizeFormatted: formattedSize,
                            category: this.selCategory,
                            date_created: new Date().toISOString()
                        };

                        console.log(`Uploading file ${i + 1}/${files.length}:`, newItem.name);

                        const url = `/api-py/file-load/${this.bip.header.year}/${this.bip.code}`;

                        // Используем await для последовательной загрузки
                        try {
                            const response = await axios.post(url, formData, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'multipart/form-data'
                                }
                            });

                            if (response.data && response.data.existed) {
                                errorMessages.push(`Файл "${file.name}" уже существует`);
                                errorCount++;
                            } else {
                                this.localFiles.push(newItem);
                                successCount++;
                            }
                        } catch (error) {
                            const errorMsg = `Ошибка загрузки файла "${file.name}": ${error.message}`;
                            errorMessages.push(errorMsg);
                            errorCount++;
                            console.error(`Error uploading ${file.name}:`, error);
                        }

                    } catch (error) {
                        errorMessages.push(`Ошибка обработки файла "${file.name}": ${error.message}`);
                        errorCount++;
                        console.error(`Error processing ${file.name}:`, error);
                    }
                }

                // Обновляем список файлов после загрузки всех
                if (successCount > 0) {
                    // передаем новый состав файлов в текущий БИП
                    this.$emit('getFiles', this.localFiles);
                }

                // Показываем результаты
                if (successCount > 0 && errorCount === 0) {
                    // Все файлы загружены успешно
                    makeToast(this, 'success', trMsg(this, MSG_SMS + 'message'),
                        trMsg(this, MSG_SMS + 'uploaded') + `: ${successCount}`);
                } else if (successCount > 0 && errorCount > 0) {
                    // Частичный успех
                    makeToast(this, 'warning', trMsg(this, MSG_SMS + 'warning'),
                        trMsg(this, MSG_SMS + 'uploaded') + `: ${successCount}, ` +
                        trMsg(this, MSG_SMS + 'error') + `: ${errorCount}. ${errorMessages.join('; ')}`);
                } else if (errorCount > 0) {
                    // Все файлы с ошибками
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'),
                        trMsg(this, MSG_SMS + 'error_load') + `: ${errorMessages.join('; ')}`);
                }

            } catch (error) {
                // console.error('Upload error:', error);
                //
                // // Определяем тип ошибки
                // let errorMessage = 'error_load';
                // let errorTitle = 'error_download';
                //
                // if (error.message.includes('Network error') || !error.response) {
                //     errorMessage = 'Ошибка сети. Проверьте подключение к интернету';
                //     errorTitle = 'warning';
                // }

                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'error_load'));
            } finally {
                // Сбрасываем input только после завершения всех операций
                setTimeout(() => {
                    if (this.$refs['file-input']) {
                        this.$refs['file-input'].reset();
                    }

                    // Сохраняем индекс категории, в которую загружаются файлы
                    this.activeTabIndex = this.categoriesWithFiles.findIndex(
                        cat => cat.code === this.selCategory
                    );
                }, 100);
                this.uploadInProgress = false;
                this.modalFileUpload = false;
            }

            // try {
            //     // Берем файл напрямую из input компонента
            //     const fileInput = this.$refs['file-input'];
            //     if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
            //         console.log('No files selected in input');
            //         return;
            //     }
            //
            //     const file = fileInput.files[0];
            //     const fileSize = file.size || 0;
            //     const formattedSize = formatFileSize(fileSize);
            //
            //     // Проверка размера файла (30 МБ = 30 * 1024 * 1024 байт)
            //     if (fileSize > maxFileSize) {
            //         makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'),
            //             trMsg(this, MSG_SMS + 'file_too_large') || ` ${formattedSize}`);
            //         return;
            //     }
            //
            //     const newName = file.name.replace(/\s+/g, "_");
            //     const newFile = this.createNewFile(file, newName);
            //
            //     const formData = new FormData();
            //     formData.append('file', newFile);
            //     formData.append('filetype', newFile.type);
            //     formData.append('filename', newFile.name);
            //     formData.append('filesize', fileSize.toString());
            //     formData.append('year', this.bip.header.year);
            //     formData.append('code', this.bip.code);
            //
            //     const newItem = {
            //         type: newFile.type,
            //         name: newFile.name,
            //         text: this.comment,
            //         size: fileSize,
            //         sizeFormatted: formattedSize,
            //         category: this.selCategory,
            //         date_created: new Date().toISOString()
            //     };
            //
            //     console.log('Upload details:', newItem);
            //
            //     const url = `/api-py/file-load/${this.bip.header.year}/${this.bip.code}`;
            //     await axios.post(url, formData,
            //       {
            //         'Accept': 'application/json',
            //         'Content-Type': 'multipart/form-data'
            //       }
            //     ).then(response => {
            //         if (response.data && response.data.existed) {
            //             makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'),
            //                 trMsg(this, MSG_SMS + 'file_exists_rename_file'));
            //         } else {
            //
            //             this.localFiles.push(newItem);
            //             this.$emit('getFiles', this.localFiles);
            //
            //           makeToast(this, 'success', trMsg(this, MSG_SMS + 'message'),
            //               trMsg(this, MSG_SMS + 'file_uploaded_success'));
            //         }
            //     }).catch((error) => {
            //         makeToast(this, 'danger', trMsg(this, MSG_SMS + 'warning'),
            //             error.toString());
            //     }).finally(() => {
            //         this.closeModal();
            //     })
            // } catch (error) {
            //     console.error('Upload error:', error);
            //
            //     // Определяем тип ошибки
            //     let errorMessage = error.message || 'Ошибка загрузки файла';
            //     let errorTitle = 'error_download';
            //
            //     if (error.message.includes('Network error') || !error.response) {
            //         errorMessage = 'Ошибка сети. Проверьте подключение к интернету';
            //         errorTitle = 'warning';
            //     }
            //
            //     makeToast(this, 'danger', trMsg(this, MSG_SMS + errorTitle), errorMessage);
            // } finally {
            //     this.uploadInProgress = false;
            //     // Сбрасываем input только после завершения всех операций
            //     setTimeout(() => {
            //         if (this.$refs['file-input']) {
            //             this.$refs['file-input'].reset();
            //         }
            //     }, 100);
            // }
        }
    },

    computed: {
        // Объект выбранной категории для multiselect; в selCategory хранится только код
        selCategoryItem: {
            get() {
                return this.categories.find(cat => cat.code === this.selCategory) || null;
            },
            set(item) {
                this.selCategory = item ? item.code : null;
            }
        },

        categoriesWithFiles() {
            return this.categories
                .filter(category => category.files && category.files.length > 0)
                .sort((a, b) => a.code.localeCompare(b.code)); // сортировка по коду
        },

        validateFText() {
            for (const file of this.localFiles) {
                // Проверяем, есть ли у файла атрибут text и не пустой ли он
                if (!file.text || file.text.trim().length === 0) {
                    return false;
                }
            }
            return true;
        }
    },

    watch: {
        // Обновляем локальную копию при изменении пропса
        bip: {
            handler(bip) {
                this.localFiles = [...bip.files];
            },
            deep: true
        },
        localFiles: {
            handler() {
                this.loadFiles();
            },
            deep: true
        },
        selCategory: {
            handler(category) {
                this.comment = '';
                if (`${i18nService.locale}` === 'kk') {
                    if (category === '2007') {
                        this.comment = (this.bip.finSourcePsd.length > 0 ? findItem(this.bip.finSourcePsd, 'code', this.fundSrcList).name + ' қаражаты есебінен құны ' : '')
                            + (this.bip.costPsd !== 0 ? Number(this.bip.costPsd).toLocaleString('ru-RU') + ' ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg') + ' болатын ' : '')
                            + (this.bip.costPsd !== 0 || this.bip.finSourcePsd.length > 0 ? 'ЖСҚ ' : '');
                    }
                    if (category === '2008') {
                        this.comment = (this.bip.finSourceGe.length > 0
                                ? findItem(this.bip.finSourceGe, 'code', this.fundSrcList).name + ' қаражаты есебінен құны ' : '')
                            + (this.bip.costGe !== 0 ?
                                Number(this.bip.costGe).toLocaleString('ru-RU') + ' ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg') + ' болатын ' : '')
                            + (this.bip.dateStateExamination !== null ? this.bip.dateStateExamination + ' күнгі ' : '')
                            + (this.bip.numStateExpertise.length > 0 ? '№ ' + this.bip.numStateExpertise.trim().replace(/^№\s*/, '') : '')
                            + (this.bip.numStateExpertise.length > 0 || this.bip.dateStateExamination !== null
                            || this.bip.costGe !== 0 || this.bip.finSourceGe.length > 0 ? ' МС' : '');
                    }
                } else {
                    if (category === '2007') {
                        this.comment = (this.bip.costPsd !== 0 || this.bip.finSourcePsd.length > 0 ? 'ПСД стоимостью ' : '')
                            + (this.bip.costPsd !== 0 ? Number(this.bip.costPsd).toLocaleString('ru-RU') + ' ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg') : '')
                            + (this.bip.finSourcePsd.length > 0
                                ? ' на средства ' + findItem(this.bip.finSourcePsd, 'code', this.fundSrcList).name : '');
                    }
                    if (category === '2008') {
                        this.comment = (this.bip.numStateExpertise.length > 0 || this.bip.dateStateExamination !== null
                            || this.bip.costGe !== 0 || this.bip.finSourceGe.length > 0 ? 'ГЭ ' : '')
                            + (this.bip.numStateExpertise.length > 0 ? '№ ' + this.bip.numStateExpertise.trim().replace(/^№\s*/, '') : '')
                            + (this.bip.dateStateExamination !== null ? ' от ' + this.bip.dateStateExamination : '')
                            + (this.bip.costGe !== 0 ?
                                ' стоимостью ' + Number(this.bip.costGe).toLocaleString('ru-RU') + ' ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg'): '')
                            + (this.bip.finSourceGe.length > 0
                                ? ' на средства ' + findItem(this.bip.finSourceGe, 'code', this.fundSrcList).name : '');
                    }
                }
            }
        },
        modalFileUpload: {
            handler(value) {
                if (value) {
                    this.selCategory = null;
                }
            }
        }
    }
};
</script>

<style scoped>
.form-group {
    margin: 5px 0 35px 0;
}
.category-select {
    text-align: left;
}
.delete-all {
    color: #d34641 !important;
    cursor: pointer;
}
.delete-all i {
    font-size: 0.6rem;
    margin-right: 0.3rem;
}
.upload-btn-label {
    font-size: 0.6rem;
    font-style: italic;
    opacity: 0.6;
}
.fileupload_file-name {
    cursor: pointer;
}
.fileupload .icon-download {
    color: #008000 !important;
    font-weight: bold;
}

.fileupload .action_btn {
    margin-right: 20px;
}

.fileupload .action_btn:active,
.fileupload .action_btn:active * {
    color: #2b3c47;
}

.fileupload .spinner {
    margin-right: 4px;
    height: 12px;
    width: 12px;
}

.fileupload {
    .nav-tabs {
        margin-bottom: 10px;
    }

    .tab-content {
        .file-info {
            .comment {
                width: 34.5%;
                margin: 15px;
            }
            .date, .icon, .name, .size, .delete {
                flex-shrink: 0; /* Запрещаем сжатие */
                margin-bottom: 0;
                margin-right: 15px;
            }

            .date {
                width: 80px;
            }
            .icon {
                width: 21px;
            }
            .size {
                width: 60px;
            }
            .delete {
                width: 100px;
            }
            .name {
                width: auto;
                min-width: 0; /* важно для правильного переноса */
                max-width: 500px; /* Максимальная ширина */
                word-wrap: break-word; /* Перенос длинных слов */
                flex: 1;

                .fileupload_file-name {
                    color: #265B86;
                    text-decoration: underline;
                    font-weight: 600;
                    margin-right: 10px;
                    word-break: break-word; /* Перенос по словам */
                    overflow-wrap: break-word; /* Современный перенос */
                    display: inline-block;
                    max-width: 100%; /* Ограничение по ширине родителя */
                    cursor: pointer;

                    &:hover {
                        color: #1a3d5c; /* Эффект при наведении */
                    }
                }
            }
        }
    }
}

.border-red {
    border: red solid 1.5px;
}

.compact-textarea {
    background-color: #fff !important;
    border: 1px solid #ced4da !important;
    padding: 10px 12px;
    width: 100%;
    font-size: 14px;
    line-height: 1.5;
    min-height: 60px;
    max-height: 200px;
    resize: vertical;
    overflow-y: auto;
    font-family: inherit;

    &:focus {
        background-color: #fff !important;
        border-color: #5B8FF9 !important;
        box-shadow: 0 0 0 0.2rem rgba(91, 143, 249, 0.25);
        outline: none;
    }

    &:disabled {
        background-color: #f8f9fa !important;
        border-color: #e9ecef !important;
        color: #6c757d;
    }
}

.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
    background-color: #B2C6DB !important;
}

.load-block.disabled .file-upload-trigger {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
    color: #999;
}
</style>